// extracted by mini-css-extract-plugin
export default {"title":"Taa-z","warning":"Uaa-z","sizeOptionsLegendText":"Vaa-z"};